import GoldenLayout from 'golden-layout';
import patchHelper from './goldenLayoutPatchHelper';

/* eslint no-underscore-dangle: ["error",
{ "allow": [
    "__lm",
    "_container",
    "_reactClass",
] }] */

// Patching internal GoldenLayout.__lm.utils.ReactComponentHandler:
const { ReactComponentHandler } = GoldenLayout.__lm.utils;

class ReactComponentHandlerPatched extends ReactComponentHandler {
  _render() {
    patchHelper.renderHandler(this);
  }

  _destroy() {
    patchHelper.destroyHandler(this);
  }

  _getReactComponent() {
    return patchHelper.getReactComponentHandler(this._container, this._reactClass);
  }
}

export default ReactComponentHandlerPatched;
